<template>
  <v-dialog
      v-model="isOpenInner"
      persistent
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span>Замена файла с данными: {{ project }}</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-file-input
              v-model="files"
              label="Файл XLSX для загрузки..."
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              :rules="[required]"
          ></v-file-input>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="isOpenInner = false">Закрыть</v-btn>
        <v-btn text color="success" @click="uploadChangeDataFile" :disabled="!valid">Загрузить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import asyncQuery from "../../../asyncQuery";

export default {
  name: "ChangeDataFileDialog",
  data: () => {
    return {
      valid: false,
      files: null,
    }
  },
  props: {
    isOpen: Boolean,
    toggleChangeDataFileDialog: Function,
    project: String,
    toggleLoading: Function,
    showMessage: Function,
    getProjects: Function,
  },
  computed: {
    isOpenInner: {
      get: function () {
        return this.isOpen;
      },
      set: function () {
        this.toggleChangeDataFileDialog();
      }
    },
  },
  methods: {
    required: value => !!value || 'Это обязательное поле.',

    uploadChangeDataFile: function () {
      const data = new FormData();
      data.append('file', this.files);
      data.append('project', this.project);

      asyncQuery.bind(this)({
        url: '/api/change_data_file',
        method: 'POST',
        body: data,
        form: true,
        handleSuccess: () => {
          this.getProjects();
          this.toggleChangeDataFileDialog();
          this.$data.valid = false
          this.$data.files = null;

          this.showMessage('Файл успешно заменён!', 'success');
        },
        handleStatus: {
          400: json => {
            this.showMessage(json.message, 'error');
          },
        }
      })
    },

  },
}
</script>
